import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import { AggregateCommandDTO } from '@/../client-generator/generated-clients/plants';
import { IDefaultDevicesSettingsDTO } from 'client-generator/generated-clients/device-settings';

@Options({
  name: 'CommandWizardStep',
  props: {
    plantId: {
      type: Number,
      required: true,
    },
    commandGroup: {
      type: Object as PropType<AggregateCommandDTO>,
    },
    defaultSettings: {
      type: Object as PropType<IDefaultDevicesSettingsDTO[]>,
      required: true,
    },
  },
  emits: ['update:defaultSettings', 'next-enabled'],
  watch: {
    nextEnabled: function () {
      this.emitIsNextEnabled();
    },
  },
})
export default class CommandWizardStep extends Vue {
  plantId!: number;
  commandGroup!: AggregateCommandDTO;
  defaultSettings!: IDefaultDevicesSettingsDTO[];

  nextEnabled = true;

  emitIsNextEnabled() {
    this.$emit('next-enabled', this.nextEnabled);
  }
}
